const membersApiRelativeURL = '/_api/members-area/_api';

export const membersApiPictureURL = `${membersApiRelativeURL}/media/credentials/picture`;
export const membersApiMediaIndexURL = `${membersApiRelativeURL}/media/index`;

export const WIX_STATIC_MEDIA = 'static.wixstatic.com/media/';
export const WIX_STATIC_MEDIA_REGEX = `^https?://${WIX_STATIC_MEDIA}`;
